const setWishlist = (state, payload) => {
    state.wishlist = payload;
};
export default {
    setWishlist
};